import React from 'react'
import PropTypes from 'prop-types'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  ResponsiveBreakpointsProvider
} from 'contexts/ResponsiveBreakpointsContext'

const ResponsiveBreakpointsLegacyScope = ({ children }) => (
  <ResponsiveBreakpointsProvider
    value={RESPONSIVE_BREAKPOINT_VERSIONS.LEGACY}>
    {children}
  </ResponsiveBreakpointsProvider>
)

ResponsiveBreakpointsLegacyScope.propTypes = {
  children: PropTypes.node
}

export default ResponsiveBreakpointsLegacyScope
